module.exports = __webpack_public_path__ + "img/tszk.fd05d6aa.jpg";